import { useContext, useState } from "react";
import MetaMaskConnect from "./MetaMaskConnect";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  return (
    <header className="main-header">
      <div className="header-sticky">
        <nav className="navbar navbar-expand-lg">
          <div className="container">

            <div className="navbar-toggle">
              <a
                href="#"
                aria-haspopup="true"
                role="button"
                tabIndex={0}
                className="slicknav_btn"
                style={{ outline: "none" }}
                onClick={toggleMenu}
              >
                <span className="slicknav_menutxt" />
                <span className="slicknav_icon slicknav_no-text">
                  <span className="slicknav_icon-bar" />
                  <span className="slicknav_icon-bar" />
                  <span className="slicknav_icon-bar" />
                </span>
              </a>
            </div>

            <div className={`collapse navbar-collapse main-menu ${menuOpen ? "menu-open" : ""}`}>
              <div className="nav-menu-wrapper">
                <ul className="navbar-nav mr-auto" id="menu">
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      Home
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      About Us
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#presale" onClick={()=>{setMenuOpen(false)}}>
                      Join Presale
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#">
                      White paper
                    </a>
                  </li>
                  <li className="nav-item submenu">
                    <a className="nav-link" href="#">
                      Services
                    </a>
                    <ul>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          Staking
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          Mining App
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          AI Chatbot
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          AI Onchain
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link" href="#">
                          AI Agent
                        </a>
                      </li>
                    </ul>
                  </li>
                
                </ul>
              </div>
            </div>
            {/* Main Menu End */}
            {/* <div className="navbar-toggle" /> */}
            <div className={`header-btn d-inline-flex ${menuOpen ? 'hidden-button-connect': ''}`} >
                <MetaMaskConnect></MetaMaskConnect>
              </div>
          </div>
      
        </nav>
       
        <div className="responsive-menu" />
      </div>
    </header>



  );
};

export default Header;
